import {Time} from "./Time";

export class RistopubAvailability {
    constructor(
        public readonly start: Time,
        public readonly end: Time
    ) {
    }
}